'use client'

import { createContext, useMemo } from 'react'
import type {
	ReturnMethodsContextData,
	ReturnMethodsData,
} from 'shipping-and-returns/types/ReturnsInfoContext.types'

export const ReturnsInfoContext = createContext<ReturnMethodsContextData>({
	maximumReturnDays: 30,
	currentReturnMethodInfo: {
		id: '',
		isFree: false,
		cost: {
			price: '',
			additionalPrices: undefined,
		},
	},
	returnMethods: [],
	hasFreeReturnMethod: false,
	hasSecondReturnsBlock: false,
	hasReturnCostSinceDate: false,
	isDroppointMethodTempDisabled: false,
})

export function ReturnsInfoProvider({
	returnData,
	returnType,
	children,
}: {
	readonly returnData: ReturnMethodsData
	readonly returnType?: string
	readonly children: React.ReactNode
}): React.ReactNode {
	const data = useMemo(
		() => ({
			...returnData,
			...(returnType && {
				currentReturnMethodInfo: returnData.returnMethods.find(
					(method) => method.id === returnType
				),
			}),
		}),
		[returnData, returnType]
	) as ReturnMethodsContextData

	return (
		<ReturnsInfoContext.Provider value={data}>
			{children}
		</ReturnsInfoContext.Provider>
	)
}
